var gql = require("@apollo/client").gql;

const MUTATE_SUBMIT_EVENT_QUERY = gql`
    mutation($query: String!, $sessionId: String, $addressId: Int) {
        sendAction(
            query: $query
            session_id: $sessionId
            action: { view_tariffs: { address_id: $addressId } }
        ) {
            id
        }
    }
`;

export default MUTATE_SUBMIT_EVENT_QUERY;
